<template>
  <div
    class="c-video__overlay position-absolute w-100 h-100 text-center d-none d-md-block"
    :class="{'active' : toggle}"
  >
    <div class="row justify-content-center h-100">
      <div class="col col-12 col-md-10 col-lg-8 h-100">
        <div
          class="d-flex flex-column align-items-center justify-content-center
          p-3 p-lg-4 h-100"
        >
          <p class="fs-21 w-bold white mb-3">
            ¡Recuerda que el acceso gratuito tiene tiempo
            limitado y no incluye certificado!
          </p>
          <p class="fs-16 w-medium white mb-4">
            Con un solo pago certificate y accede a +100
            cursos de arquitectura, diseño e Ingeniería. ¿Qué esperas?
          </p>
          <a
            href="/planes"
            class="c-button c-button--primary d-inline-block medium mb-2 px-5"
          >
            Ver planes
          </a>
          <button
            @click="close()"
            class="c-link c-link--primary"
          >
            Seguir viendo gratis
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    player: Object,
    toggle: Boolean,
  },
  methods: {
    close() {
      this.$emit('update:toggle', false);
      this.player.play();
    },
  },
};
</script>
